import { Box, Typography, CardMedia } from "@mui/material";
import classNames from "classnames";
import React, { FC, useEffect, useState } from "react";
import { formatVideoName, IVideo } from "../../../videos/hooks/useFetchVideos";
import placeholder from "../../../../../assets/video_placeholder.png";
import { ReactComponent as CheckIcon } from "../../../../../assets/svg/checkIcon.svg";

interface Props {
    video: IVideo;
    isSelected?: boolean;
    onClick?: (e: number) => void;
}

const SingleVideoToSelect: FC<Props> = ({ video, isSelected, onClick }) => {
    const [source, setSource] = useState("");

    useEffect(() => {
        const url = video.location || video.reviewS3File?.location || placeholder;
        setSource(url?.replace(".mp4", "_thumbnail.png") || "");
    }, [video]);

    const formatName = (videoObject: IVideo) => {
        const name = videoObject?.title || videoObject?.name || videoObject?.key || "";
        return formatVideoName(name);
    };

    return (
        <div
            onClick={() => onClick?.(video.id)}
            className={classNames("flex gap-7 cursor-pointer hover:bg-surface-2", {
                "!bg-tint": isSelected
            })}
            title={formatName(video)}
        >
            <Box className="relative shrink-0">
                <CardMedia
                    component="img"
                    style={{ height: 110, width: 180 }}
                    image={source}
                    alt=""
                    className="rounded-lg"
                />
                <Box className="absolute bottom-2 right-2 flex gap-3">
                    <Typography className="bg-surface rounded-lg px-2" color="text.secondary">
                        {video.aspect_ratio}
                    </Typography>
                    <Typography className="bg-surface rounded-lg px-2" color="text.secondary">
                        3:45
                    </Typography>
                </Box>
            </Box>
            <Box className="flex gap-2 py-2 flex-col w-full">
                <Box className="flex align-center gap-2">
                    <CardMedia component="img" image={source} className="rounded-md grow-1 shrink-0 !h-6 !w-6" />
                    <Typography
                        className="font-normal !text-sm !w-[210px]"
                        style={{
                            overflow: "hidden",
                            textWrap: "nowrap",
                            textOverflow: "ellipsis"
                        }}
                        color="text.secondary"
                    >
                        {formatName(video)}
                    </Typography>
                </Box>
                <Typography
                    className="!font-black !text-lg w-full"
                    style={{
                        minHeight: 32,
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        // @ts-ignore
                        "-webkit-box-orient": "vertical",
                        textOverflow: "ellipsis"
                    }}
                    color="text.secondary"
                >
                    {formatName(video)}
                </Typography>
                <Box className="flex gap-3 items-center">
                    <CardMedia
                        component="img"
                        image={source}
                        alt=""
                        className="rounded-xl border border-surface !w-6 !h-6"
                    />
                    <Typography className="text-muted text-xs">Angela Espinosa</Typography>
                </Box>
            </Box>
            {isSelected && (
                <Box className="flex items-center justify-center w-[56px] h-[110px] shrink-0">
                    <CheckIcon />
                </Box>
            )}
        </div>
    );
};
export default SingleVideoToSelect;
